export class NewParticipantModelReq {
    "userId":Number;
    "studyId":Number
}